import { render, staticRenderFns } from "./IntroVideo.vue?vue&type=template&id=b0d3a33a&scoped=true&"
import script from "./IntroVideo.vue?vue&type=script&lang=js&"
export * from "./IntroVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0d3a33a",
  null
  
)

export default component.exports